<template>
  <div>
    <div class="recharge">
      <div class="nav acea-row row-around row-middle">
        <div
          class="item"
          :class="active === key ? 'on' : ''"
          v-for="(item, key, index) in navRecharge"
          :key="index"
          @click="changPayType(key)"
        >
          {{ item }}
        </div>
      </div>
      <div v-if="active === 'alipay'">
        <div v-if="isEditAlpay()" class="inp-box">
          <input v-model="alipay_id" placeholder="支付宝账号" class="input" />
          <input
            v-model="alipay_name"
            placeholder="支付宝真实姓名"
            class="input"
          />
          <div class="save" @click="saveAlipay">保存继续提现</div>
        </div>
        <div v-else class="alipay-tip">
          提现账户
          <span class="to-vip" @click="editAlipay = true"
            >【{{ user.alipay_id }}】</span
          >
        </div>
      </div>
      <div v-if="!isEditAlpay()" class="info-wrapper">
        <div class="money">
          <span>￥</span>
          <input
            type="number"
            step="1"
            :readonly="freeze ? 'readonly' : false"
            :placeholder="freeze ? '冻结中' : '0.00'"
            v-model="money"
            @change="money = parseInt(money)"
          />
        </div>
        <div class="tips">
          提示：当前余额为<span>￥{{ now_money || 0 }}</span
          ><br />{{ cash_money ? "每次" : "首次" }}提现最低
          <span>￥{{ cash_money ? 10 : min_cash_money }}</span
          >元
        </div>
        <!--<div v-if="!is_vip" class="vip-tip">-->
        <!--<strong>VIP</strong>用户可提现-->
        <!--<span class="to-vip" @click="toVip">【升级VIP】</span>-->
        <!--</div>-->
        <div class="pay-btn bg-color-red" @click="recharge">立即提现</div>
      </div>
    </div>
  </div>
</template>
<script>
import { isWeixin } from "@utils";
import { cashWechat, getBalance, saveAlipay } from "@api/user";
// import { add, sub } from "@utils/bc";

export default {
  name: "Recharge",
  components: {},
  props: {},
  data: function() {
    return {
      navRecharge: { alipay: "提现到支付宝", weixin: "提现到微信" },
      active: "alipay",
      from: isWeixin() ? "weixin" : "weixinh5",
      money: "",
      now_money: "",
      freeze: 0,
      min_cash_money: 1,
      is_vip: 0,
      consume: 0,
      alipay_id: "",
      alipay_name: "",
      editAlipay: false,
      user: {},
      cash_money: 0,
      loading: false
    };
  },
  watch: {
    $route(to) {
      if (to.name !== "Recharge") return;
      this.getBalance();
    }
  },
  computed() {},
  mounted: function() {
    this.getBalance();
  },
  methods: {
    getBalance() {
      this.money = "";
      getBalance().then(
        res => {
          this.user = res.data;
          this.cash_money = this.user.cash_money * 1;
          this.alipay_id = res.data.alipay_id;
          this.alipay_name = res.data.alipay_name;
          this.now_money = res.data.money;
          this.freeze = res.data.freeze;
          this.consume = res.data.consume;
          //this.min_cash_money = res.data.min_cash_money;
          // this.min_cash_money = this.cash_money ? 10 : this.min_cash_money;
          this.is_vip = res.data.is_vip;
        },
        err => {
          this.$dialog.message(err.msg);
        }
      );
    },
    changPayType(key) {
      if (key === "weixin") {
        this.$dialog.toast({ mes: "请暂时使用支付宝提现！" });
        return;
      }
      this.action = key;
    },
    saveAlipay() {
      if (!this.alipay_id || !this.alipay_name) {
        this.$dialog.toast({ mes: "请填写完整账号在提交" });
        return;
      }
      let data = { alipay_id: this.alipay_id, alipay_name: this.alipay_name };
      saveAlipay(data)
        .then(r => {
          Object.assign(this.user, data);
          this.$dialog.success(r.msg);
          this.editAlipay = false;
        })
        .catch(msg => {
          this.$dialog.error(msg);
        });
    },
    isEditAlpay() {
      if (this.active !== "alipay") {
        return false;
      }
      if (this.editAlipay) {
        return true;
      }
      if (this.user.alipay_id && this.user.alipay_name) {
        return false;
      } else {
        return true;
      }
    },
    toVip() {
      alert(
        `尊敬的用户您好，累计消费满99元即可升级成为VIP用户，您当前消费￥${
          this.consume
        }`
      );
    },
    recharge: function() {
      let that = this,
        money = Number(this.money);
      // if (!this.is_vip) {
      //   return that.$dialog.toast({ mes: "请升级成为VIP用户后提现" });
      // } else
      if (this.freeze == 1) {
        return that.$dialog.toast({ mes: "无法体现，资金冻结中" });
      } else if (money === 0) {
        return that.$dialog.toast({ mes: "请输入您要提现的金额" });
      } else if (money < this.min_cash_money) {
        return that.$dialog.toast({
          mes: `提现金额不能低于${this.min_cash_money}`
        });
      } else if (money > this.now_money) {
        this.money = this.now_money;
        return that.$dialog.toast({ mes: `提现金额不能高于${this.now_money}` });
      }
      if (this.loading) return;
      this.loading = true;
      this.$dialog.loading.open();

      cashWechat({ money, pay_type: this.active })
        .then(res => {
          that.$dialog.success(res.msg);
          that.$router.replace({
            path: "/user/account"
          });
        })
        .catch(msg => {
          that.$dialog.error("系统错误：" + msg);
        })
        .finally(() => {
          this.loading = false;
          this.$dialog.loading.close();
        });
    }
  }
};
</script>
<style scoped>
#iframe {
  display: none;
}
.inp-box {
  margin: 0.3rem auto;
  background: #2a7efb;
  padding: 0.3rem 0.3rem 0.5rem 0.3rem;
  border-radius: 0.2rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.input {
  border-bottom: 1px solid #ededed;
  padding: 0.47rem 0 0.13rem 0;
  position: relative;
  display: block;
  color: #ffffff;
  width: 100%;
}
.save {
  margin-top: 0.5rem;
  box-sizing: border-box;
  border-radius: 0.45rem;
  border: 1px solid #ffffff;
  color: #ffffff;
  text-align: center;
  padding: 0.15rem 0.2rem;
  box-shadow: 1px 2px 3px #ffffff;
}
.alipay-tip {
  margin-top: 0.3rem;
  color: #999999;
}
.input::-webkit-input-placeholder {
  color: #fff;
}
.input::-moz-input-placeholder {
  color: #fff;
}
.input::-ms-input-placeholder {
  color: #fff;
}
.vip-tip {
  margin-top: 0.25rem;
  font-size: 0.26rem;
}
.to-vip {
  color: #2a7efb;
}
.recharge {
  width: 7.03rem;
  padding: 0.5rem 0.63rem 0.45rem;
  background-color: #fff;
  margin: 0.2rem auto 0 auto;
  border-radius: 0.1rem;
}
.recharge .nav {
  height: 0.75rem;
  line-height: 0.75rem;
  padding: 0 1rem;
}
.recharge .nav .item {
  font-size: 0.3rem;
  color: #333;
}
.recharge .nav .item.on {
  font-weight: bold;
  border-bottom: 0.04rem solid #e83323;
}
.recharge .info-wrapper {
  text-align: center;
}
.recharge .info-wrapper .money {
  margin-top: 0.6rem;
  padding-bottom: 0.2rem;
  border-bottom: 1px dashed #ddd;
}
.recharge .info-wrapper .money span {
  font-size: 0.56rem;
  color: #333;
  font-weight: bold;
}
.recharge .info-wrapper .money input {
  display: inline-block;
  width: 3.5rem;
  font-size: 0.84rem;
  text-align: center;
  color: #282828;
  font-weight: bold;
  padding-right: 0.7rem;
}
.recharge .info-wrapper .money input::placeholder {
  color: #ddd;
}
.recharge .info-wrapper .money input::-webkit-input-placeholder {
  color: #ddd;
}
.recharge .info-wrapper .money input:-moz-placeholder {
  color: #ddd;
}
.recharge .info-wrapper .money input::-moz-placeholder {
  color: #ddd;
}
.recharge .info-wrapper .money input:-ms-input-placeholder {
  color: #ddd;
}
.recharge .info-wrapper .tips {
  font-size: 0.26rem;
  color: #888;
  margin: 0.25rem auto 0 auto;
  line-height: 1.5;
  padding: 0 0.3rem;
}
.recharge .info-wrapper .tips span {
  color: #ef4a49;
}
.recharge .info-wrapper .pay-btn {
  display: block;
  width: 5.5rem;
  height: 0.86rem;
  margin: 0.5rem auto 0 auto;
  line-height: 0.86rem;
  text-align: center;
  color: #fff;
  border-radius: 0.5rem;
  font-size: 0.3rem;
  font-weight: bold;
}
</style>
